import { useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { ForecastsElementManager } from "../workflows/forecastsWorkflow";
import {LionLoaderGradient} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'

import { getErrorListFromYupError, getErrorMessage, snippetDataValidationSchemaWeatherForecasts } from '../components/helperErrors'
import { CcActionButton } from "../commonComponents/styledTexts";

export default function PageForecastsFromTemplate() {
    const [snippetData, setSnippetData] = useState({});

    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [weatherModeTag, setweatherModeTag] = useState('city') //either city or airport. For now only city is implemented. This is only used to show the desired merge codes in the tag

    const [activeErrorList, setActiveErrorList] = useState([]);
    
    let params = useParams();
    const navigate = useNavigate();

    const handleClose = () => {
        navigate('/ph/forecasts')
    }

    const handleElementChange = (snippetInfo) => {
        setSnippetData(snippetInfo)
        if (activeErrorList.length > 0) {
            try {
                snippetDataValidationSchemaWeatherForecasts.validateSync(snippetInfo, {abortEarly: false});
                setActiveErrorList([])
              }
              catch (e) {
                const errorList = getErrorListFromYupError(e)
                setActiveErrorList(errorList)
              }    
        }
      }
      
    const submitDataSnippet = async () => {
        try {
            snippetDataValidationSchemaWeatherForecasts.validateSync(snippetData, {abortEarly: false});
            setActiveErrorList([])
          }
          catch (e) {
            const errorList = getErrorListFromYupError(e)
            setActiveErrorList(errorList)
            console.log(errorList)
            return;
          }

    setShowLoader(true);
    setSuccessHtmlMsg('');
    
    try {
        let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/18`;
        
        const response = await axios.post(url, {...snippetData, snippetSettings: JSON.stringify(snippetData.snippetSettings)});
    
        setSuccessHtmlMsg(response.data);
        setShowSuccessMsg(true);
    } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
    }
    setShowLoader(false);
    setSubmitted(true)
    }

    return <div>
        {!submitted && !showLoader &&
        <ForecastsElementManager
            onChange={handleElementChange}
            templateId={params.templateId}
            validationErrorsList={activeErrorList}
        />
        }
        <div className='flex flex-col items-center mt-20 mb-5'>
            {showLoader && <LionLoaderGradient /> }
            {showSuccessMsg && <><SnippetCodeViewer numSnippets={1} 
                                    html={successHtmlMsg} weatherMode={weatherModeTag} />

                                <div className='flex flex-row w-[676px]'><div className='mt-6 text-ccColorDarkTeal text-lg font-semibold'>Merge codes</div></div>
                                <div class="inline-flex w-[676px] rounded-md font-poppins text-ccColorDarkTeal" role="group">
                                        <div className={`cursor-pointer px-4 py-2 w-56 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${weatherModeTag === 'city' ? 'bg-gray-200' : 'bg-white'}`}
                                            onClick={()=>setweatherModeTag('city')}
                                            >
                                        <div>
                                            City & Country
                                        </div>
                                        <div className='text-sm mt-2 font-normal'>Merge cities and country codes as the locations to have the forecasts for</div>
                                        </div>
                        {/*
                                        <div className={`cursor-pointer px-4 py-2 w-56 font-medium border-t border-b border-gray-200 focus:outline-none focus:ring-0 hover:bg-gray-100 hover:text-ccColorTeal ${props.units === 'metric' ? 'bg-gray-200' : 'bg-white'}`}
                                            //onClick={()=>handleUnitsChange('metric')}
                                            >
                                        <div>
                                        City & Country & State
                                        </div>
                                        <div className='text-sm mt-2 font-normal'>For temperature in Celsius and wind speed in meter/sec</div>
                                        </div>
                        */}
                                        <div className={`cursor-pointer px-4 py-2 w-56 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${weatherModeTag === 'state' ? 'bg-gray-200' : 'bg-white'}`}
                                            onClick={()=>setweatherModeTag('state')}
                                            >
                                        <div>
                                        City & Country & State
                                        </div>
                                        <div className='text-sm mt-2 font-normal'>Merge also a state if you need forecasts for ambiguous city names, e.g. London, US, Kentucky and London, US, Ohio</div>
                                        </div>
                                </div>

                                 </>   
                                }      
        </div>        

        <div className='flex flex-col gap-4 justify-center items-center'>
            {!submitted && !showLoader &&  <div className="w-1/2 flex flex-row-reverse">
                <CcActionButton onClick={submitDataSnippet}>Submit</CcActionButton>
                </div>
            }
            {submitted &&  <div className="w-1/2 flex flex-row-reverse">
                <CcActionButton onClick={handleClose}>Close</CcActionButton>
                </div>
            }
        </div>
    </div>
}
